<app-header-frame-module [isAdmin]="isAdmin"></app-header-frame-module>

<div class="container-fluid">
    <h2>{{'Importer une trame' | uppercase}}</h2>
    <hr>
    <div class="row">
        <div class="col-lg-7 p-2 pr-2 frame-form">
            <div>
                <mat-form-field appearance="outline" class="w-50 p-2">
                    <mat-label>Nom du fournisseur</mat-label>
                    <mat-select [(value)]="selectedSupplier" [disabled]="lockSupplier">
                        <mat-option *ngFor="let supp of suppliers" [value]="supp">{{supp.companyName ? supp.companyName
                            : supp.code}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-50 p-2">
                    <mat-label>Type d'import</mat-label>
                    <mat-select [(value)]="selectedImportType" (valueChange)="resetForm()">
                        <mat-option [value]="importTypeEnum.PRODUIT">{{importTypeEnum.PRODUIT}}s</mat-option>
                        <mat-option [value]="importTypeEnum.TARIF">{{importTypeEnum.TARIF}}s</mat-option>
                    </mat-select>
                </mat-form-field>
                <p *ngIf="isProduct" class="px-2">Il faut garder uniquement les feuilles qui sont utilisées, le reste doit être supprimé.</p>
            </div>
            <div class="p-2">
                <div class="bold">Import de la trame Excel :</div>
                <p>Veuillez exporter la trame avant d'importer</p>
                <button mat-raised-button class="btn mb-3" (click)="exportFile()">EXPORTER</button>

                <p>Choisissez un fichier *.xlsx</p>
                <button mat-raised-button class="btn" (click)="filePickerPrice.click()">
                    {{'Sélectionner votre fichier'|uppercase}}
                </button>
                <input type="file" #filePickerPrice style="display: none;" (change)="onFrameLoad($event)">
                <span class="filename" *ngIf="frame">{{ frame.name }}</span>
            </div>
            <hr *ngIf="isProduct">
            <div class="p-2" *ngIf="isProduct">
                <div class="bold">Import des photos :</div>
                <p>Choisissez vos fichiers images (*.jpg, *.png...) ou *.zip</p>
                <button mat-raised-button class="btn" (click)="filePickerImg.click()">
                    {{'Sélectionner vos fichiers'|uppercase}}
                </button>
                <input type="file" #filePickerImg style="display: none;" (change)="onPicturesLoad($event)" multiple>
                <span class="filename" *ngIf="pictures">
                    <ul>
                        <li *ngFor="let picture of pictures">{{ picture.name }}</li>
                    </ul>
                </span>
            </div>
            <hr *ngIf="isProduct">
            <!-- <div class="p-2" *ngIf="isProduct">
                <div class="bold">Import des documents :</div>
                <p>Choisissez vos fichiers *.pdf ou *.zip</p>

                <div class="md-2">
                    <button mat-raised-button class="btn" (click)="filePickerDoc.click()">
                        {{'Sélectionner vos fichiers ft'|uppercase}}
                    </button>
                    <input type="file" #filePickerDoc style="display: none;" (change)="onDocsLoad($event)" multiple>
                    <span class="filename" *ngIf="docs">
                        <ul>
                            <li *ngFor="let doc of docs">{{ doc.name }}</li>
                        </ul>
                    </span>
                </div>
                
                <div class="md-2">
                    <button mat-raised-button class="btn" (click)="filePickerDoc.click()">
                        {{'Sélectionner vos fichiers fds'|uppercase}}
                    </button>
                    <input type="file" #filePickerDoc style="display: none;" (change)="onDocsLoad($event)" multiple>
                    <span class="filename" *ngIf="docs">
                        <ul>
                            <li *ngFor="let doc of docs">{{ doc.name }}</li>
                        </ul>
                    </span>
                </div>
                
                <div class="md-2">
                    <button mat-raised-button class="btn" (click)="filePickerDoc.click()">
                        {{'Sélectionner vos fichiers certifs'|uppercase}}
                    </button>
                    <input type="file" #filePickerDoc style="display: none;" (change)="onDocsLoad($event)" multiple>
                    <span class="filename" *ngIf="docs">
                        <ul>
                            <li *ngFor="let doc of docs">{{ doc.name }}</li>
                        </ul>
                    </span>
                </div>
              
            </div> -->
            <div class="p-2" *ngIf="isProduct">
                <div class="bold">Import des documents :</div>
                <p>Choisissez vos fichiers *.pdf ou *.zip</p>
            
                <div class="d-flex gap-2">
                    <div class="md-2">
                        <button mat-raised-button class="btn" (click)="filePickerDocFt.click()">
                            {{'Sélectionner vos fichiers ft'|uppercase}}
                        </button>
                        <input type="file" #filePickerDocFt style="display: none;" (change)="onDocsFtLoad($event)" multiple>
                        <span class="filename" *ngIf="docsFt">
                            <ul>
                                <li *ngFor="let doc of docsFt">{{ doc.name }}</li>
                            </ul>
                        </span>
                    </div>
            
                    <div class="md-2">
                        <button mat-raised-button class="btn" (click)="filePickerDocFds.click()">
                            {{'Sélectionner vos fichiers fds'|uppercase}}
                        </button>
                        <input type="file" #filePickerDocFds style="display: none;" (change)="onDocsFdsLoad($event)" multiple>
                        <span class="filename" *ngIf="docsFds">
                            <ul>
                                <li *ngFor="let doc of docsFds">{{ doc.name }}</li>
                            </ul>
                        </span>
                    </div>
            
                    <div class="md-2">
                        <button mat-raised-button class="btn" (click)="filePickerDocCertif.click()">
                            {{'Sélectionner vos fichiers certifs'|uppercase}}
                        </button>
                        <input type="file" #filePickerDocCertif style="display: none;" (change)="onDocsCertifLoad($event)" multiple>
                        <span class="filename" *ngIf="docsCertif">
                            <ul>
                                <li *ngFor="let doc of docsCertif">{{ doc.name }}</li>
                            </ul>
                        </span>
                    </div>
                </div>
            </div>
            
            <hr>
            <div class="d-flex justify-content-center align-items-center mb-3">
                <mat-form-field appearance="outline" class="col-8">
                    <mat-label>Date de publication de la trame</mat-label>
                    <input matInput type="date" [(ngModel)]="publicationDate" [min]="dateString">
                </mat-form-field>
                <button mat-raised-button class="btn-primary px-2" (click)="validate()"
                    [disabled]="!isValid">VALIDER</button>
            </div>
        </div>
        <div class="col-lg-5 pl-2 frame-result">
            <div *ngIf="!submitted">
                <p>Résultat de l'import</p>

                <div *ngIf="frameUploadInProgress" class="my-3">
                    <p style="font-style: italic;">L'import de la trame est {{frameUploadProgress == 100 ? 'terminé':'en cours, veuillez patienter...'}}</p>
                    <div class="progress-bar-container">
                        <mat-progress-bar mode="determinate" [value]="frameUploadProgress"
                            class="custom-progress-bar"></mat-progress-bar>
                        <div class="progress-bar-label">{{ frameUploadProgress }}%</div>
                    </div>
                </div>

                <div *ngIf="picturesUploadInProgress" class="my-3">
                    <p style="font-style: italic;">L'import des images est {{picturesUploadProgress == 100 ?
                        'terminé':'en cours, veuillez patienter...'}}</p>
                    <div class="progress-bar-container">
                        <mat-progress-bar mode="determinate" [value]="picturesUploadProgress"
                            class="custom-progress-bar"></mat-progress-bar>
                        <div class="progress-bar-label">{{ picturesUploadProgress }}%</div>
                    </div>
                </div>

                <div *ngIf="docsUploadInProgress" class="my-3">
                    <p style="font-style: italic;">L'import des documents est {{docsUploadProgress == 100 ?
                        'terminé':'en cours, veuillez patienter...'}}</p>
                    <div class="progress-bar-container">
                        <mat-progress-bar mode="determinate" [value]="docsUploadProgress"
                            class="custom-progress-bar"></mat-progress-bar>
                        <div class="progress-bar-label">{{ docsUploadProgress }}%</div>
                    </div>
                </div>

                <button *ngIf="frameUploadInProgress" mat-raised-button color="warn" class="btn my-2" (click)="cancelUpload()">ANNULER</button>

                <div *ngIf="reportDone">
                    <p>L'import des données <strong>{{isProduct ? 'Produits' : 'Tarifs'}}</strong> est terminé</p>
                    <hr>
                    <ul style="list-style: none;" class="p-0">
                        <li>Nombre de lignes traitées : {{ importStats.totalLines }}</li>
                        <!-- <li>Nombre de lignes ignorées : {{ importStats.ignoredLines }}</li> -->
                        <li class="text-success">Nombre de lignes valides : {{ importStats.validLines }}</li>
                        <li class="text-warning">Nombre de lignes avec alerte : {{ importStats.alertLines }}</li>
                        <li class="text-warning">Nombre d'articles dépubliés : {{ importStats.nbDepublie }}</li>
                        <li class="text-danger">Nombre de lignes en erreur : {{ importStats.errorLines }}</li>
                    </ul>

                    <div class="form-group">
                        <!-- <textarea id="report" class="form-control" rows="10" readonly>
                        {{ reportDetails }}
                      </textarea>
                       -->
                       <div id="report-bloc"></div>
                    </div>

                    <div class="d-flex justify-content-between mt-3">
                        <button mat-raised-button class="btn" (click)="downloadReport()">{{'Télécharger le rapport'| uppercase}}</button>
                        <button mat-raised-button class="btn-primary" (click)="submitForValidation()">{{'Soumettre pour validation'| uppercase}}</button>
                    </div>
                </div>
            </div>
            <div *ngIf="submitted" class="d-flex flex-column justify-content-center align-items-center text-center"
                style="min-height: 300px;">
                <mat-icon id="check-icon">check_circle</mat-icon> <!-- done -->
                <p class="valid-msg">{{"L'import de la trame est soumis pour validation"|uppercase}}</p>
            </div>
        </div>

    </div>

</div>